import { zIndexMap } from '@Backlot-Cars/archie';
import { inter } from 'fonts';
import { createGlobalStyle } from 'styled-components';

const igniteCompatibilityFixes = `
	table {
		border-collapse: separate;
	}
`;

const AppGlobalStyles = createGlobalStyle`
	:root {
		--fontFamily: ${inter.style.fontFamily}, sans-serif;
		--ignite-photo-gallery-z-index: ${zIndexMap.modal};
	}

	.intercom-app,
	.intercom-lightweight-app {
		z-index: ${zIndexMap.intercom} !important;
	}

	@media screen and (max-width: 993px) {
		.intercom-lightweight-app .intercom-launcher, .intercom-dfosxs {
			bottom: 73px !important;
		}
	}
	${igniteCompatibilityFixes}
`;

export default AppGlobalStyles;
